import { UserRole } from '@shared/models';

import { SideMenuItem } from './menu-item';

export const adminMenu: SideMenuItem[] = [
  {
    label: 'layout.menu.admin',
    items: [
      {
        label: 'layout.menu.adminDashboard',
        icon: 'pi pi-fw pi-home',
        routerLink: ['/app', 'admin', 'dashboard'],
      },
    ],
  },
  {
    label: 'layout.menu.systemContent',
    roles: [UserRole.Admin],
    items: [
      {
        label: 'layout.menu.instructions',
        icon: 'pi pi-fw pi-file',
        routerLink: ['/app', 'instructions'],
      },
      {
        label: 'layout.menu.instructionTemplates',
        icon: 'pi pi-fw pi-file-edit',
        routerLink: ['/app', 'instruction-templates'],
      },
    ],
  },
  {
    label: 'layout.menu.administration',
    roles: [UserRole.Admin],
    items: [
      {
        label: 'admin.announcements.title',
        icon: 'pi pi-megaphone',
        routerLink: ['/app', 'admin', 'announcements'],
      },
      {
        label: 'layout.menu.companies',
        icon: 'pi pi-fw pi-briefcase',
        routerLink: ['/app', 'admin', 'companies'],
      },
      {
        label: 'layout.menu.users',
        icon: 'pi pi-fw pi-user-edit',
        routerLink: ['/app', 'admin', 'users'],
      },
      {
        label: 'layout.menu.appLogs',
        icon: 'pi pi-fw pi-microchip',
        routerLink: ['/app', 'admin', 'app-logs'],
      },
      {
        label: 'layout.menu.emailQueue',
        icon: 'pi pi-fw pi-envelope',
        routerLink: ['/app', 'admin', 'email-queue'],
      },
      {
        label: 'layout.menu.registrationRequests',
        icon: 'pi pi-fw pi-inbox',
        routerLink: ['/app', 'admin', 'registration-requests'],
      },
    ],
  },
];
